import React, { useEffect, useState } from "react";
import api from '../../../config/axiosConfig';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import loaderGif from "../../../assets/loader.gif";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import { saveAs } from 'file-saver';

const Report = () => {
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [filters, setFilters] = useState({
        dateRange: "all",
        accountName: "",
        bookingId: "",
        status: "",
    });

    const getData = async () => {
        try {
            setLoader(true);
            const dataResponse = await api.get("/orders/orderlist");
            setData(dataResponse.data);
        } catch (error) {
            console.error('Fetching data failed:', error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const applyFilters = () => {
        let filtered = [...data];

        if (filters.accountName) {
            filtered = filtered.filter(item => item.accountName?.toLowerCase().includes(filters.accountName.toLowerCase()));
        }
        if (filters.bookingId) {
            filtered = filtered.filter(item => String(item.bookingId).includes(filters.bookingId));
        }
        if (filters.status) {
            filtered = filtered.filter(item => item.StatusName?.toLowerCase().includes(filters.status.toLowerCase()));
        }
        if (filters.dateRange !== "all") {
            const now = new Date();
            filtered = filtered.filter(item => {
                const itemDate = new Date(item.createddate);
                if (filters.dateRange === "today") {
                    return itemDate.toDateString() === now.toDateString();
                }
                if (filters.dateRange === "week") {
                    const startOfWeek = new Date(now);
                    startOfWeek.setDate(now.getDate() - now.getDay());
                    const endOfWeek = new Date(startOfWeek);
                    endOfWeek.setDate(startOfWeek.getDate() + 6);
                    return itemDate >= startOfWeek && itemDate <= endOfWeek;
                }
                if (filters.dateRange === "month") {
                    return itemDate.getMonth() === now.getMonth() && itemDate.getFullYear() === now.getFullYear();
                }
                if (filters.dateRange === "year") {
                    return itemDate.getFullYear() === now.getFullYear();
                }
                return true;
            });
        }

        return filtered;
    };

    const filteredData = applyFilters();

    const generateExcel = async () => {
        try {
            const url = `/orders/generatereport`;
            const method = 'post';
    
            const response = await api({
                method,
                url,
                responseType: 'blob', // <--- VERY IMPORTANT
                data: {
                    data: filteredData, // pass if needed
                }
            });
    
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'report.xlsx');
    
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <Container fluid>
            <Row className="mb-1">
                <Col md={3}>
                    <Form.Select onChange={(e) => setFilters(prev => ({ ...prev, dateRange: e.target.value }))}>
                        <option value="all">All</option>
                        <option value="today">Today</option>
                        <option value="week">This Week</option>
                        <option value="month">This Month</option>
                        <option value="year">This Year</option>
                    </Form.Select>
                </Col>
                <Col md={9}>
                    <Row className="mb-3">
                        <Col md={4}>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon1">Account Name</InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    placeholder="Account Name"
                                    onChange={(e) => setFilters(prev => ({ ...prev, accountName: e.target.value }))}
                                />
                            </InputGroup>
                        </Col>
                        <Col md={4}>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon1">Booking ID</InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    placeholder="Booking ID"
                                    onChange={(e) => setFilters(prev => ({ ...prev, bookingId: e.target.value }))}
                                />
                            </InputGroup>
                        </Col>
                        <Col md={4}>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="basic-addon1">Status</InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    placeholder="Status"
                                    onChange={(e) => setFilters(prev => ({ ...prev, status: e.target.value }))}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md={3}>
                    <Button
                        variant="success"
                        size="sm"
                        onClick={() => generateExcel()}
                    >
                        Generate Excel
                    </Button>
                </Col>
            </Row>
            <Row className="mt-4">
                {loader ? (
                    <div className="text-center w-100">
                        <img src={loaderGif} alt="Loading..." style={{ width: "50px" }} />
                    </div>
                ) : (
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Customer</th>
                                <th>Reference</th>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Notes</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.accountName}</td>
                                        <td>{item.referenceCode}</td>
                                        <td>{item.itemName}</td>
                                        <td>{item.quantity}</td>
                                        <td>₹{item.price}</td>
                                        <td>{item.notes}</td>
                                        <td>{item.StatusName}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center">No data found.</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="4"><strong>Total</strong></td>
                                <td colSpan="3">
                                    ₹{filteredData.reduce((acc, item) => acc + (parseFloat(item.price) || 0), 0)}
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                )}
            </Row>
        </Container>
    );
};

export default Report;
